import React from 'react';
import { SvgIcon, makeStyles,} from '@material-ui/core';
import variables from '../../assets/bootstrap/scss/_variables.scss';

interface IconsSVG {
    props?: any;
}

//Scss variable
const textColor = variables.mainText;

const useStyles = makeStyles({
    root: {
        fill: textColor
    },
});

const FaceThree = ({ props } : IconsSVG ) => {
    const classes = useStyles();
    return (
        <SvgIcon {...props} className={classes.root} viewBox="-2.5 -2 40 40">
            <path d="M17.5,0C7.8,0,0,7.8,0,17.5C0,27.2,7.8,35,17.5,35C27.2,35,35,27.2,35,17.5C35,7.8,27.2,0,17.5,0z M17.5,31.5   c-7.7,0-14-6.3-14-14c0-7.7,6.3-14,14-14c7.7,0,14,6.3,14,14C31.5,25.2,25.2,31.5,17.5,31.5z"/>
	        <path d="M23.2,22.8H11.8c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3h11.3c0.7,0,1.3-0.6,1.3-1.3   C24.5,23.4,23.9,22.8,23.2,22.8z"/>
	        <circle r="2.4" cy="13" cx="11.2"/>
            <circle r="2.4" cy="13" cx="23.8"/>
        </SvgIcon>
  );
}

export default FaceThree;